import { CustomerProduct } from '../../clients/customer-api/product/customer-product';
import { Location } from '../../clients/quipli-service/location/location';
import { displayMoneyFormat } from '../../util/util';
import { ProductImageV2 } from '../../components/image/product/product-image-v2';

import './product-card.scss';
import { useContext } from 'react';
import { TenantContext } from '../../context/tenant-context';
import { Typography } from '../../components/typography/typography';
import { Dictionary } from 'lodash';
import { Configuration } from '../../clients/quipli-service/configuration/configuration';
import { Label } from '../../clients/quipli-service/label/label';
import { RentalProductPrice } from '../../clients/quipli-service/pricing/pricing';
import { ProductTrackingType } from '../../clients/quipli-service/product/product';

export const ProductCard = ({
  product,
  location,
  isLoggedIn = false,
  rentalPrices,
  salePrice,
  labels,
  configs,
  tagDiscount,
}: {
  product: CustomerProduct;
  location?: Location & { urlAlias: string };
  isLoggedIn: boolean;
  rentalPrices?: RentalProductPrice[];
  salePrice?: number;
  labels: Dictionary<Label>;
  configs: Dictionary<Configuration>;
  tagDiscount: number;
}) => {
  const { contextPath } = useContext(TenantContext);
  const featuredRentalPrices = rentalPrices && rentalPrices.filter((p) => p.featured);

  const showEvenIfOutOfStock = configs['CONF_ECOMMERCE_SALE_REQUIRE_IN_STOCK']?.value === '0';
  return (
    <div
      className={`product-card-v2 ${
        product.trackingType != ProductTrackingType.NonInventory &&
        product.allowSale &&
        !product.allowRent &&
        product.saleStock <= 0 &&
        !showEvenIfOutOfStock
          ? 'out-of-stock'
          : ''
      }`}
    >
      <a className="" href={`${contextPath}${location?.urlAlias ? `${location.urlAlias}/` : ''}${product.urlKeyword}`}>
        <div className="product-card-image ">
          <ProductImageV2
            className="object-contain"
            productId={product.id}
            profile="MEDIUM"
            alt={product.altTitles ? product.altTitles[0] : product.name}
          />
        </div>
        <div>
          <div className="product-name text-center p-1">
            <Typography type="text-md" weight="semi-bold">
              {product.name}
            </Typography>
          </div>

          {product.allowRent && featuredRentalPrices?.length ? (
            <div className="price-section">
              {configs['CONF_USER_UNAPPROVED_HIDE_PRICES'].value === '1' && !isLoggedIn ? (
                <div className="price">Sign in to see pricing</div>
              ) : product.allowRent && product.hidePrices ? (
                <div className="price">Contact for pricing</div>
              ) : (
                product.allowRent && (
                  <>
                    {featuredRentalPrices.map((price) => (
                      <div className="price">
                        <span className="price-label">Per {price.durationLabel}</span>
                        <span className="price-value">
                          {' '}
                          {displayMoneyFormat(
                            (price.price * tagDiscount) / 100,
                            location?.currency ?? configs['CONF_CURRENCY']?.value,
                          )}
                        </span>
                      </div>
                    ))}
                  </>
                )
              )}
            </div>
          ) : (
            <></>
          )}
          {product.allowSale && (
            <div className="price-section">
              <div className="price">
                {configs['CONF_ECOMMERCE_SALE_REQUIRE_IN_STOCK'].value === '1' &&
                  product.trackingType != ProductTrackingType.NonInventory &&
                  !product.allowRent &&
                  product.saleStock <= 0 && (
                    <span className="text-sm text-[var(--error-500)] bold">
                      {labels['L_Out_of_Stock']?.caption ?? 'Out of Stock'}
                    </span>
                  )}
                <>
                  <span className="price-label">{labels['L_BUILD_PRODUCT']?.caption ?? 'Buy Now'}</span>
                  {configs['CONF_USER_UNAPPROVED_HIDE_PRICES'].value === '1' && !isLoggedIn ? (
                    <span className="price-value">Sign in to see price</span>
                  ) : product.hideSalePrices ? (
                    <span className="price-value">Contact for pricing</span>
                  ) : (
                    <span className="price-value">
                      {' '}
                      {salePrice
                        ? displayMoneyFormat(
                            (salePrice * tagDiscount) / 100,
                            location?.currency ?? configs['CONF_CURRENCY']?.value,
                          )
                        : 'N/A'}
                    </span>
                  )}
                </>
              </div>
            </div>
          )}
        </div>
      </a>
    </div>
  );
};
